(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ShipmentApplicationImmediateCreditDownloadController',ShipmentApplicationImmediateCreditDownloadController);

    ShipmentApplicationImmediateCreditDownloadController.$inject = ['$uibModalInstance'];

    function ShipmentApplicationImmediateCreditDownloadController($uibModalInstance) {
        var vm = this;

        vm.insuranceOptions = ["CIF", "CFR"];
        vm.blOptions = ["OBL", "Copy BL"];

        vm.formElement = {
            insurance: "CIF",
            obl: "OBL"
        }

        vm.clear = clear;
        vm.submit = submit;
        vm.updateInsurance = updateInsurance;
        vm.updateBl = updateBl;

        function updateInsurance(option) {
            vm.formElement.insurance = option;
        }

        function updateBl(option) {
            vm.formElement.obl = option;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function submit() {
            $uibModalInstance.close(vm.formElement);
        }
    }
})();
